var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "6.11 7 17.78 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.18 23H8.82a1 1 0 0 1-1-.8l-1.7-8.6a.5.5 0 0 1 .49-.6h16.78a.5.5 0 0 1 .49.6l-1.72 8.6a1 1 0 0 1-.98.8M14 9V8a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V10a1 1 0 0 0-1-1Z"
})));
export default SvgFolderOpen;